import { ButtonSelectMultiple } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { ItemBinding } from "../../../../clients/graphqlTypes.js";
import { type ItemChange, useItemBindings } from "../hooks/useItemBindings.js";

interface Props {
  label?: string;
  hasAgreement?: boolean;
  value: (ItemBinding | ItemChange)[];
  onChange: (value: (ItemBinding | ItemChange)[]) => void;
}

export const ButtonItemBindingSelectMultiple = ({
  label,
  hasAgreement,
  value,
  onChange,
}: Props) => {
  const { itemBindingOptions, itemBindingWithChangeOptions } =
    useItemBindings();
  const { t } = useTranslate(["Global", "QuoteItem"]);
  return (
    <ButtonSelectMultiple
      label={label ?? t("State", { ns: "QuoteItem" })}
      searchLabel={t("Search", { ns: "Global" })}
      noOptionsLabel={t("There are no items to display", {
        ns: "Global",
      })}
      options={hasAgreement ? itemBindingWithChangeOptions : itemBindingOptions}
      value={value}
      onChange={onChange}
      popoverWidth="md"
    />
  );
};
